import { render, staticRenderFns } from "./Lang2Age2.vue?vue&type=template&id=0af385b9&scoped=true&"
import script from "./Lang2Age2.vue?vue&type=script&lang=js&"
export * from "./Lang2Age2.vue?vue&type=script&lang=js&"
import style0 from "./Lang2Age2.vue?vue&type=style&index=0&id=0af385b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af385b9",
  null
  
)

export default component.exports